import { render, staticRenderFns } from "./detail_card.vue?vue&type=template&id=cbce5730&scoped=true"
import script from "./detail_card.vue?vue&type=script&lang=js"
export * from "./detail_card.vue?vue&type=script&lang=js"
import style0 from "./detail_card.vue?vue&type=style&index=0&id=cbce5730&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce5730",
  null
  
)

export default component.exports